import axios from '../../../service/index'
import React, { Component } from 'react'
import {Button, Input, Icon, Spin} from 'antd'
import './search.less'
class SearchPosters extends Component {
  state = {
    userId: '',
    activityName: '',
    ActivityList: [],
    loading: false
  }
  componentDidMount() {
    this.InitHandle()
    this.setState({userId: this.props.location.state.userId})
  }
  InitHandle() {
    // this.setState({loading: true})
    axios.post('activityxetback/query',{activityName: this.state.activityName}).then(res => {
      // this.setState({loading: false})
      if(res.data.code === '200'){
        this.setState({ActivityList: res.data.data.list})
      }
    })
  }
  activeName(e) {
    this.setState({activityName: e.target.value},() => {
      this.InitHandle()
    })
  }
  render() {
    return (
      <div className="search">
        <Spin spinning={this.state.loading}>
        <div className="inp-top">
        
          <Input placeholder="搜索海报" value={this.state.activityName} prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)'}}></Icon>} allowClear onChange={(e) => {this.activeName(e)}} />
          <Button onClick={() => {
            this.setState({activityName:''})
            this.props.history.push('/activity')}} type="link">取消</Button>
        </div>
        {
          this.state.ActivityList.length>0?
          <ul className="content">
            {
              this.state.ActivityList.map(item => {
                return (
                  <li key={item.id}>
                    <img src={item.activityCover} alt="" />
                    <div className="rig">
                      <h4>{item.activityName}</h4>
                      <p>{item.activityStart}-{item.activityEnd}</p>
                      <div className="bot">
                        <span className="tip">{new Date(item.activityEnd).getTime()>new Date().getTime()?'直播':'录播'}</span>
                        <span className="bot-btn" onClick={() => {this.props.history.push('/savimg',{id: item.id, userId: this.state.userId})}}>生成海报</span>
                      </div>
                    </div>
                  </li>
                )
              })
            }
          </ul>
          :
          <div className="data-img">暂无数据</div>
        }
        </Spin>
      </div>
    )
  }
}
export default SearchPosters